import React, { useState,useEffect } from "react";
import { HeroText } from '../../components';
import { Loader } from '../../components';
import { FormWebinar } from '../../components';

const LandingWebinar = (props) => {
  const [isFetching, setisFetching] = useState(true);
  const imgHero = require('../../assets/header_webinar.png');

  const arrayLoad = [
    imgHero
  ]
  useEffect(() => {
    document.title = "3D Commerce is Here! Get the Full View with Invrsion and Sketchfab - Webinar"
  });
  return (
    <React.Fragment>

      <HeroText 
        title="3D Commerce is Here! Get the Full View with Invrsion and Sketchfab - Webinar" 
        subtitle=""
        image={imgHero}
        align="right"
        isLanding={true}
        isImage={true}
        isWebinar={true}
        date="26 January at 12 pm EST"
        place="Zoom"
      />
     <FormWebinar 
      title="2022: the year of 3D Commerce. Are you ready?" 
      paragraph="Hear from the leaders in 3D Commerce about the next evolution of shopping. Join our <b>Webinar</b> on <b>Wednesday January 26th at 12 pm EST</b>.<br/><br/><b>Sketchfab (recently acquired by Epic Games) CEO, Alban Denoyel</b>, will be joined by <b>Invrsion’s CEO, Matteo Esposito, and CMO North America Jeff Minsky</b> to discuss how you can drive exponential customer satisfaction and increase ROI through beautiful, informative, hyper-realistic 3D imaging.<br/><br/>Discover the advantages of using 3D real-time rendered Digital Twins.<br/><b>Don’t miss</b> our fourth Workshop where we give you the <b>Full View of 3D Commerce!</b>"
    />

    </React.Fragment>
  );
};

export default LandingWebinar;
